<template>
  <div id="my_collection">
    <div class="tabbar">
      <div :class="item===selectItem?'isAcitve':''" v-for="(item,index) in tabbarItem" :key="index">
        {{item}}
      </div>
    </div>
    <div class="filter">
      <div class="select_ground">
        <div class="select_game">
          <el-select v-model="selectGameValue" :popper-append-to-body="false" placeholder="选择游戏" clearable @change="selectChange">
            <el-option
              v-for="item in selectGame"
              :key="item.value"
              :label="item.label"
              :value="{value:item.value,label:item.label}">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="filter_search">
        <input type="text" v-model="match" class="filter_search_input" placeholder="请输入账户关键词">
        <span class="filter_search_btn" @click="clickMatch">确认</span>
      </div>
    </div>
    <div class="product_list">
      <el-table
        :data="tableData"
        style="width: 100%">
        <!-- 空数据 -->
        <template slot="empty">
          <div class="no_data">
            <empty-state
              title="暂无收藏装备"
              description="可以调整筛选条件后再次查看"
              icon="el-icon-star-off"
              :icon-size="52">
            </empty-state>
          </div>
        </template>
        <!-- 商品信息 -->
        <el-table-column
          :label="'商品信息（'+totalCount+'条）'"
          width="510">
          <template slot-scope="scope">
            <div class="product">
              <div class="product__img">
                <el-image :src="scope.row.image"></el-image>
<!--                <img v-if="scope.row.image" :src="scope.row.image" alt="">-->
<!--                <img v-else src="https://images.pxb7.com/images/equip/20220214/20220214170100_361766.png" alt="">-->
              </div>
              <div class="product_info">
                <el-tooltip
                  effect="light"
                  placement="top-start"
                  popper-class="collection-product-title-tooltip"
                  :content="scope.row.game_name + ' ' + scope.row.name"
                  :disabled="!scope.row.productTitleOverflow">
                  <div class="product_info_top" :ref="'productTitle' + scope.$index">
                    <span class="product_game_name">{{ scope.row.game_name }}</span>
                    <span class="product_name">{{ scope.row.name }}</span>
                  </div>
                </el-tooltip>
                <div class="product_info_mid">
                  <span class="gaming_zone" v-for="(categoryItem,index) in scope.row.category" :key="index">
                    {{categoryItem.name}}：
                    <span>
                      {{categoryItem.value}}
                    </span>
                  </span>
                </div>
                <div class="product_info_bot">
                  <span id="release_date">发布时间：{{ scope.row.add_time|moment }}</span>
                  <span id="browse">
<!--                    <img src="@/assets/image/Home/topGamesIco.png" alt="">-->
                    热度：
                    <span>
                      {{ scope.row.click }}
                    </span>
                  </span>
                  <span id="collect">收藏：{{ scope.row.collect }}</span>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <!-- 金额 -->
        <el-table-column
          label="金额">
          <template slot-scope="scope">
            <div class="product_price">¥{{scope.row.sell_price}}</div>
          </template>
        </el-table-column>
        <!-- 库存 -->
        <el-table-column
          label="库存">
          <template slot-scope="scope">
            <div class="num">{{scope.row.num}}</div>
          </template>
        </el-table-column>
        <!-- 状态 -->
        <el-table-column
          label="状态"
          width="111">
          <template slot-scope="scope">
            <div slot="reference" class="name-wrapper">
              <el-tag v-if="scope.row.status===1" size="medium">待审核</el-tag>
              <el-tag v-else-if="scope.row.status===2" type="warning" size="medium">在售</el-tag>
              <el-tag v-else-if="scope.row.status===3" type="info" size="medium">下架</el-tag>
              <el-tag v-else-if="scope.row.status===4" type="danger" size="medium">审核失败</el-tag>
            </div>
          </template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column
          label="操作"
          width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.status===2" class="btn_ground">
              <div class="view_detail" @click.stop="viewDetail(scope.row)">查看详情</div>
              <!-- <div class="seeking_price_cuts" @click.stop="seeking_price_cuts_confirm(scope.row)">求降价</div> -->
              <a class="ask_service" @click.stop="cusSerBtnClicks(scope.row)">咨询客服</a>
              <!-- <a v-else target="_blank" class="ask_service" @click.stop="$accessLink(scope.row.game_customer_buy)" :href="`${scope.row.game_customer_buy}?u_cust_id=${$store.state.userData.user_id}&u_cust_name=${$store.state.userData.nickname}`">咨询客服</a> -->
              <div class="off_shelf" @click.stop="collectDel(scope.row)">取消收藏</div>
            </div>
            <div v-else class="btn_ground">
              <div class="off_shelf" @click.stop="collectDel(scope.row)">取消收藏</div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pages" v-if="totalCount !== 0">
        <common-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="PageSize"
          layout="prev, pager, next, jumper"
          :total="totalCount">
        </common-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import CommonPagination from "@/components/commonPagination";
import EmptyState from "@/components/emptyState";
import {apiHistoryCusAdd,apiGameList, apiCollectListEquip, apiBargainAddEquip, apiCollectEquip, apiBargainClcik, apiProductBuyCheck} from "@/request/API";

export default {
  name: '',
  props: {
  },
  components: {
    CommonPagination,
    EmptyState
  },
  data () {
    return {
      // 默认显示第几页
      currentPage:1,
      // 总条数，根据接口获取数据长度(注意：这里不能为空)
      totalCount:0,
      // 默认每页显示的条数（可修改）
      PageSize:10,
      selectItem:'游戏装备',
      tabbarItem:[
        '游戏装备'
      ],
      tableData: [],
      //选择游戏下拉框
      selectGame: [],
      selectGameValue: '',
      //搜索关键词
      match:'',
      //分页页码
      page:1
    }
  },
  methods: {
    /**
     * 立即购买按钮
     */
     onlineBuy(game_id, id, game_name){
      if (!this.$store.state.loginStatus) {
        this.$message({
          type: "error",
          message: '尚未登录，请先登录。',
          center: true
        })
        this.$router.push({
          path: '/login',
          query: {
            Rurl: this.$route.fullPath,
            game_name: game_name,
            game_id: game_id,
            id: id,
          },
        })
        return;
      }
      apiProductBuyCheck({
        game_id:game_id,
        id:id,
      }).then(res=>{
        let routeUrl = this.$router.resolve({
          name: 'OnlineDeal',
          query: {
            id: id,
            game_id:game_id
          }
        });
        window.open(routeUrl.href, '_blank');
      }).catch(e => {
        this.$message.error(e.msg)
      })
    },
    cusSerBtnClicks(item) {
      apiHistoryCusAdd({
        game_id: item.game_id,
        product_id: item.acc_id,
        product_type: 2
      })
      if(item.acc_id && item.game_id){
        this.$customerShunt.getBuyOrGroupCode(item.acc_id, item.game_id, 2, (data) => {
          if(data.game_buy_status){
            data.allot_group_buy_status ? this.onlineBuy(item.game_id, item.acc_id, item.game_name) : this.$openIM({
              game_id: item.game_id,
              shopid: item.acc_id,
              product_type: 2,
              gameAlias: data.group_code,
              im_type: 3
            })
          } else {
            this.$openIM({
              game_id: item.game_id,
              shopid: item.acc_id,
              product_type: 2,
              gameAlias: data.group_code,
              im_type: 3
            })
          }
        })
      } else {
        this.$openIM({
          game_id: item.game_id,
          shopid: item.acc_id,
          product_id: item.acc_id,
          product_type: 2,
          gameAlias: item.game_alias,
        })
      }
    },
    //table监听事件
    handleEdit(index, row) {
    },
    handleDelete(index, row) {
    },
    viewDetail(row){
      this.$router.push({
        name:'EquipmentDetails',
        query:{
          game_id:row.game_id,
          id:row.acc_id
        }
      });
    },
    //分页监听事件
    handleCurrentChange(val) {
      this.getCollectionList(this.selectGameValue.value,this.match,val)
    },
    //选择游戏 下拉框 监听
    selectChange(event){
      this.getCollectionList(event.value,this.match,this.page)
    },
    //关键词搜索
    clickMatch(){
      this.getCollectionList(this.selectGameValue.value,this.match,this.page)
    },
    updateProductTitleOverflow(){
      this.$nextTick(() => {
        this.tableData.forEach((item, index) => {
          const ref = this.$refs['productTitle' + index]
          const el = Array.isArray(ref) ? ref[0] : ref
          const isOverflow = el ? el.scrollHeight > el.clientHeight + 1 : false
          this.$set(item, 'productTitleOverflow', isOverflow)
        })
      })
    },
    /**
     * 获取 我的收藏 数据
     * @param game_id  游戏ID
     * @param match    关键字
     * @param page     分页页码
     */
    getCollectionList(game_id,match,page){
      apiCollectListEquip({
        game_id:game_id,
        match:match,
        page:page,
      }).then(res=>{
        this.totalCount = res.data.total
        this.tableData = res.data.list
        this.updateProductTitleOverflow()
      })
    },
    //求降价按钮点击事件
    seeking_price_cuts_confirm(data){
      // apiBargainClcik({
      //   game_id:data.game_id,
      //   id:data.acc_id,
      // }).catch(err=>{
      //   this.$message({
      //     type:"error",
      //     message:err.msg,
      //     center:true
      //   })
      // })
      const h = this.$createElement;
      this.$msgbox({
        title:'',
        message: h('div', {class:'confirm_content'}, [
          h('div', {class:'confirm_original_price'}, '原价：'+data.sell_price+''),
          h('div',{class:'confirm_modify_bid'}, [
            h('div', {class:'confirm_modify_bid_text'}, '我的出价：'),
            h('input', {class:'confirm_modify_bid_input',attrs:{placeholder: "输入我出的价格",id:'confirm_modify_bid_input'}}),
          ]),
          h('div', {class:'confirm_modify_bid_tips'},'（提示：24小时内只能求降价1次）'),
        ]),
        confirmButtonText: '确认发起',
        confirmButtonClass:'change_price_confirm_btn',
        customClass: 'add_price_confirm',
        closeOnClickModal:false,
        showClose:true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            const price = document.getElementById("confirm_modify_bid_input").value
            if((price+'').includes('.')) {
              this.$message({
                type: "error",
                message: '价格不支持小数',
                center: true
              })
              return
            }
          }
          done()
        },
        callback: action => {
          if(action === "confirm"){
            apiBargainAddEquip({
              game_id:data.game_id,
              product_id:data.acc_id,
              price:document.getElementById("confirm_modify_bid_input").value
            }).then(res=>{
              this.$message({
                message:"发起降价请求成功",
                center:true,
                type:'success'
              })
              this.getCollectionList(this.selectGameValue.value,this.match,this.page)
            }).catch(err=>{
              this.$message({
                center:true,
                message:err.msg,
                type:'error'
              })
            })
          }
          document.getElementById("confirm_modify_bid_input").value = ''
        }
      });
    },
    //取消收藏按钮点击事件
    collectDel(data){
      apiCollectEquip({
        game_id: data.game_id,
        acc_id: data.acc_id
      }).then(res=>{
          this.$message({
            type:"success",
            center:true,
            message:"取消收藏成功"
          })
          this.getCollectionList(this.selectGameValue.value,this.match,this.page)
      }).catch(err=>{
        this.$message({
          type:"error",
          center:true,
          message:err.msg
        })
      })
    },
    //初始化数据
    onLoad(){
      apiGameList({
      }).then(res=>{
        res.data.forEach((item,index)=>{
          let options = new Object()
          options.value = item.game_id
          options.label = item.game_name
          this.selectGame.push(options)
        })
      })
      apiCollectListEquip({
      }).then(res=>{
        this.totalCount = res.data.total
        this.tableData = res.data.list
        this.updateProductTitleOverflow()
      })
    }
  },
  mounted () {
    if(typeof(this.$route.params.selectItem) !== 'undefined'){
      this.selectItem = this.$route.params.selectItem
    }
    //初始化数据
    this.onLoad()
    window.addEventListener('resize', this.updateProductTitleOverflow)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.updateProductTitleOverflow)
  },
  watch: {

  },
  computed: {

  }
}
</script>

<style lang="less">
.collection-product-title-tooltip{
  max-width: 360px;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
  line-height: 20px;
}

.add_price_confirm{
  width: 500px !important;
  height: 320px !important;
  background: #FFFFFF !important;
  border-radius: 4px !important;
  padding: 0;
  border: none;
  overflow: hidden;
  box-shadow: none;
  filter: drop-shadow(0 18px 46px rgba(26, 29, 36, 0.14));

  .el-message-box__header>.el-message-box__title{
    display: none;
  }

  .el-message-box__header{
    height: 54px;
    padding: 0;
    background: var(--bg-dark, #1A1D24);
  }

  .el-message-box__content{
    display: flex;
    flex-direction: column;
    padding: 32px 58px 0;
  }

  .el-message-box__btns{
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 20px 34px;
  }

  .el-message-box__title{
    margin-top: 0;
    font-size: 18px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 54px;
  }

  .el-message-box__container{
    margin-top: 0;
    font-size: 15px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: var(--text-secondary, #5A5F6B);
    line-height: 22px;
  }

  .el-message-box__headerbtn{
    top: 17px;
    right: 20px;
    width: 20px;
    height: 20px;
  }

  .el-message-box__close{
    color: rgba(255, 255, 255, 0.86);
    font-size: 18px;
    transition: color .2s ease, transform .2s ease;
  }

  .el-message-box__headerbtn:hover .el-message-box__close{
    color: #FFFFFF;
    transform: rotate(90deg);
  }

  .change_price_confirm_btn{
    margin-top: 0;
    padding: 0;
    width: 200px;
    height: 40px;
    line-height: 40px;
    background: var(--primary, #FF5A1F) !important;
    border-radius: 4px;
    border: none;
    font-size: 15px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 500;
    color: #FFFFFF !important;
    transition: box-shadow .2s ease, background .2s ease;
  }

  .change_price_confirm_btn:hover{
    background: var(--primary-hover, #E84A12) !important;
    box-shadow: 0 10px 22px rgba(255, 90, 31, 0.20);
  }

  .confirm_content{
    display: flex;
    flex-direction: column;
  }

  .confirm_original_price{
    font-size: 20px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 600;
    color: var(--primary, #FF7A1A);
    line-height: 28px;
    margin-bottom: 20px;
  }

  .confirm_my_bid{
    font-size: 15px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: var(--text-secondary, #5A5F6B);
    line-height: 22px;
    margin-bottom: 20px;
  }

  .confirm_modify_bid{
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .confirm_modify_bid_text{
    font-size: 15px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 500;
    color: var(--text-secondary, #5A5F6B);
    line-height: 40px;
  }

  .confirm_modify_bid_input{
    width: 250px;
    height: 40px;
    background: var(--bg-tag, #F0EDE8);
    border-radius: 4px;
    border: 1px solid var(--border-soft, #E8E4DE);
    padding: 0 14px;
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: var(--text-main, #111827);
    line-height: 22px;
    outline: none;
    transition: border-color .2s ease, box-shadow .2s ease, background .2s ease;
  }

  .confirm_modify_bid_input:hover{
    border-color: var(--border-strong, #D8D2CA);
  }

  .confirm_modify_bid_input:focus{
    border-color: var(--primary, #FF5A1F);
    background: #FFFFFF;
    box-shadow: none;
  }

  .confirm_modify_bid_tips{
    margin-left: 75px;
    font-size: 13px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: var(--text-muted, #9AA0AC);
    line-height: 20px;
  }

  .confirm_modify_bid_input::-webkit-input-placeholder {
    font-size: 14px;
    color: var(--text-muted, #9AA0AC);
  }
}

</style>
<style lang='less' scoped>
@import "./collectionList.less";

#my_collection .product_list .product .product_info{
  width: 350px;
}
</style>
